import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import ContainerApFacturacion from "./ContainerApFacturacion";
import { useLocation } from "react-router-dom";
import ResumenPoliza from "./ResumenContainer";
import { urlCreaFacturacionAP, urlGuardarDatosFacturacionC, urlViewFacturacionAP } from "../../constants/urls";
import { useToasts } from "react-toast-notifications";
import TotalesPoliza from "./TotalesPoliza";
import { makeDatosContratante, makeDatosPagadorFacturacion, resolverUbicacionEmpresa } from "./utils/ContratanteUtils";
import { apiPost2 } from "../../api";
import { sumByPrima, calcularDerechoEmision } from "./utils/planesUtils";

const toNumber = (v) => {
  const n = Number(v);
  return isFinite(n) ? n : 0;
};

const ComponentApFacturacionResumen = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const [loading, setLoading] = useState(false);
  const [facturacion, setFacturacion] = useState({});
  const [valoresGlobales, setValoreGlobales] = useState({});
  const { addToast } = useToasts();

  useEffect(() => {
    recuperarPoliza();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const recuperarPoliza = async () => {
    window.scrollTo(0, 0);
    setLoading(true);

    try {
      const response = await fetch(String(urlViewFacturacionAP), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id }),
      });
      const json = await response.json();

      if (json && json.transaccion) {
        const carrito = json.facturacion || {};
        const carProductos = Array.isArray(carrito.carProductos) ? carrito.carProductos : [];
        const producto = carProductos.length > 0 ? carProductos[0] : {};
        console.log("🚀 ~ recuperarPoliza ~ producto:", producto)

        // -------- Datos base del JSON (sin optional chaining) --------
        const asegurados = Array.isArray(producto.asegurados) ? producto.asegurados : [];
        const numPersonas =
          toNumber(producto.numPersonas) || (Array.isArray(producto.asegurados) ? producto.asegurados.length : 0);

        const totalesPorPlan = Array.isArray(producto.totalesPorPlan) ? producto.totalesPorPlan : [];
        const impuestos = [
          {
            nombre: "Superintendencia (1.5%)",
            valor: carrito.valorTotal.super_bancos_Full_Cobertura
          },
          {
            nombre: "Seguro Campesino (0.5%)",
            valor: carrito.valorTotal.seguro_campesino_Full_Cobertura
          }
        ];

        
        const impuestosSum = carrito.valorTotal.totalImpuestos || 0;
        const primaNetaTotal = carrito.valorTotal.prima_neta_anual_full_cobertura || 0;
        const totalPoliza = carrito.valorTotal.totalcarrito
          ? carrito.valorTotal.totalcarrito
          : 0;
        
        // Misma lógica que el Resumen Global de FormularioPlanes
        const planesGuardados = Array.isArray(producto.planes) ? producto.planes : [];
        let total_prima_neta;
        let impuestos_sum;
        if (planesGuardados.length > 0) {
          const sumPrimaNetaPlanes = planesGuardados.reduce((acc, p) => acc + sumByPrima(p.coberturas), 0);
          const sumAsistencias = planesGuardados.reduce((acc, p) => acc + sumByPrima(p.asistencias), 0);
          const subtotalNum = sumPrimaNetaPlanes + sumAsistencias;
          total_prima_neta = +subtotalNum.toFixed(2);
          impuestos_sum = +(subtotalNum * 0.04).toFixed(2);
        } else {
          // Fallback al valor persistido
          const totalesGlobales = producto.totalesGlobales || {};
          total_prima_neta = toNumber(totalesGlobales.subtotalPersona);
          impuestos_sum = toNumber(totalesGlobales.impuestosPersona);
        }

        const derechosEmision = calcularDerechoEmision(total_prima_neta);

        const valoresTotales = {
          total_prima_neta,
          impuestos_sum,
          total_poliza: +(total_prima_neta + impuestos_sum + toNumber(derechosEmision)).toFixed(2)
        }
        setValoreGlobales(valoresTotales);

        // Conteo de asegurados por planCodigo
        var countsByPlan = {};
        for (var i = 0; i < asegurados.length; i++) {
          var code = asegurados[i] && asegurados[i].planCodigo;
          if (!code) continue;
          countsByPlan[code] = (countsByPlan[code] || 0) + 1;
        }

        // Filas por plan (usando totalesPorPlan y cantidades reales)
        var detallePlanes = [];
        var asistencias =0;
        for (var j = 0; j < totalesPorPlan.length; j++) {
          var p = totalesPorPlan[j] || {};
          var codigo = p.codigo || ("plan_" + j);
          var cant = countsByPlan[codigo] || 0;
          if (cant === 0 && asegurados.length === 0) {
            cant = producto.numPersonas;
          }
          var primaNetaPersona = toNumber(p.primaNeta);
          var primaBrutaPersona = toNumber(p.primaTotal);
           
          detallePlanes.push({
            nombre: p.nombre || ("Plan " + (j + 1)),
            codigo: codigo,
            cantidad_asegurados: cant,
            subtotal_prima_neta: primaNetaPersona,
            subtotal_prima_bruta: primaBrutaPersona,
            // disponible en fuente: totalPlanPersona (por persona)
            totalPlanPersona: toNumber(p.totalPlanPersona)
          });
        }

        // Sumas de tabla (neta y bruta)
        var totalPrimaNeta = 0;
        var totalPrimaBruta = 0;
        for (var k = 0; k < detallePlanes.length; k++) {
          totalPrimaNeta += toNumber(detallePlanes[k].subtotal_prima_neta);
          totalPrimaBruta += toNumber(detallePlanes[k].subtotal_prima_bruta);
        }

        // Impuestos SOLO desde producto.impuestos
        
        // TOTAL GENERAL:
        // 1) Preferir totalPersona * numPersonas (si viene en totalesGlobales)
        var totalUI= producto.totalesGlobales;
        var totalGeneral = 0;
        if (producto.totalesGlobales && typeof producto.totalesGlobales.totalPersona !== "undefined") {
          totalGeneral = toNumber(producto.totalesGlobales.totalPersona) * Math.max(numPersonas, 0);
        } else {
          // 2) Fallback: sumar totalPlanPersona * cantidad por cada plan
          for (var z = 0; z < totalesPorPlan.length; z++) {
            var planTmp = totalesPorPlan[z] || {};
            var codeTmp = planTmp.codigo || ("plan_" + z);
            var cantTmp = countsByPlan[codeTmp] || 0;
            totalGeneral += toNumber(planTmp.totalPlanPersona) * cantTmp;
          }
        }

        var totalPorAsegurado = numPersonas > 0 ? (totalGeneral / numPersonas) : 0;
        
        const payload = {
          // Dejo el carrito completo por compatibilidad con ResumenPoliza
          ...carrito,
          producto: producto,
          totales: {
            detallePlanes: detallePlanes,
            total_prima_neta: primaNetaTotal,
            total_prima_bruta: totalPrimaBruta,
            derechosEmision: derechosEmision,
            impuestos_listado: impuestos,
            impuestos_sum: impuestosSum,
            total_general: totalGeneral,
            num_asegurados: numPersonas,
            total_por_asegurado: totalPorAsegurado,
            total_poliza: totalPoliza,
            resumenPlanesUI:totalUI,
          }
        };
        console.log('totales', payload);
        

        setFacturacion(payload);
      } else {
        const msg = (json && json.mensaje) || "No se pudo recuperar la póliza";
        addToast(msg, { appearance: "error" });
        setFacturacion({});
      }
    } catch (error) {
      console.error(error);
      addToast("Error, recuperar Planes", { appearance: "error" });
      setFacturacion({});
    } finally {
      setLoading(false);
    }
  };

const guardarConfirmacion = async () => {
  window.scrollTo(0, 0);
  setLoading(true);
  try {
    const totalGeneral =
  facturacion && facturacion.totales && typeof facturacion.totales.total_general !== "undefined"
    ? Number(facturacion.totales.total_general)
    : 0;

    // 1) Confirmación backend
    const respConfirm = await fetch(String(urlCreaFacturacionAP), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        idCarrito: id,
        pasoCarrito: "confirmacion",
        total:totalGeneral
      }),
    });
    const jsonConfirm = await respConfirm.json();

    if (jsonConfirm && jsonConfirm.transaccion) {
      addToast(jsonConfirm.mensaje || "Confirmación exitosa", { appearance: "success" });

      // ============================
      // 2) NUEVO: Guardar datos facturación
      // ============================
      const carrito = facturacion || {};
      const producto = carrito.producto || (Array.isArray(carrito.carProductos) ? carrito.carProductos[0] : {}) || {};

      // Resolver labels de provincia/ciudad desde la API antes de construir el contratante
      const { provinciaObj, ciudadObj } = await resolverUbicacionEmpresa(carrito);

      const datosContratante = makeDatosContratante(carrito, provinciaObj, ciudadObj);
      const datosPagador = makeDatosPagadorFacturacion(producto);

      // Validación: el carrito debe tener datos del contratante guardados
      if (!datosContratante || (!datosContratante.identificacion && !datosContratante.razonSocial)) {
        addToast("No se encontraron datos del contratante en el carrito. Verifique el paso de contratante.", { appearance: "error" });
        return;
      }

      if (!datosPagador) {
        addToast("No se pudieron construir los datos del pagador", { appearance: "error" });
        return;
      }

      const datosPagadorLimpio = datosPagador;

      const datosJSON = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        datosContratante: datosContratante,          // ✅ datos reales del contratante (datosContratanteEmpresa/Persona)
        datosPagadorFacturacion: datosPagadorLimpio, // datos del pagador del producto
        idCarrito: id,
        ambiente: "Desarrollo",
      };

      try {
         const respGuardar = await apiPost2(urlGuardarDatosFacturacionC, datosJSON);
        // const respGuardar = await fetch(String(urlGuardarDatosFacturacionC), {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify(datosJSON),
        // });
        const res = respGuardar;
        console.log("res ",props.datosCotizador.urlSiguiente)
        if (res && res.transaccion) {
          // OK → continuar flujo
          props.history.push({ pathname: props.datosCotizador.urlSiguiente, search: "?id=" + id });
          
        } else {
          // Ya existe póliza o error genérico
          const errTipo = (res && res.errorTipo) ? res.errorTipo : "";
          if (errTipo.includes("Ya existe una póliza con ese carrito")) {
            console.log("props.datosCotizador.urlSiguiente",props.datosCotizador.urlSiguiente)
            props.history.push({ pathname: props.datosCotizador.urlSiguiente,search: "?id=" + id });
          } else {
            addToast("Ocurrió un error al guardar la información: " + (errTipo || res.errorDescripcion || ""), {
              appearance: "error",
            });
          }
        }
      } catch (e) {
        console.error(e);
        addToast("Ocurrió un error al guardar la información", { appearance: "error" });
      }
      // ============================

    } else {
      addToast((jsonConfirm && jsonConfirm.mensaje) || "No se pudo confirmar", { appearance: "error" });
    }
  } catch (error) {
    console.error(error);
    addToast("Error, Guardar Datos Vidas", { appearance: "error" });
  } finally {
    setLoading(false);
  }
};
  return (
    <ContainerApFacturacion paso={"confirmacion"} titulo={props.datosCotizador.titulo}>
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={loading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Obteniendo datos..."
            >
              <Row>
                <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
                  <ResumenPoliza data={facturacion} />
                </Col>
                <Col lg={4} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
                  <TotalesPoliza
                    totales={facturacion.totales || {}}
                    confirmacion={guardarConfirmacion}
                    globales={valoresGlobales}
                  />
                </Col>
              </Row>

              <Card>
                <CardBody style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <Button
                    onClick={function () {
                      props.history.push({
                        pathname: props.datosCotizador.urlRegresar,
                        search: "?id=" + id,
                      });
                    }}
                    style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                  >
                    <i className="fa fa-chevron-circle-left" /> &nbsp;REGRESAR
                  </Button>
                </CardBody>
              </Card>
            </LoadingScreen>
          </div>
        </div>
      </main>
    </ContainerApFacturacion>
  );
};

export default ComponentApFacturacionResumen;
